export const CREATE_SUITES_STAFF_REQUESTED = 'CREATE_SUITES_STAFF_REQUESTED'
export const CREATE_SUITES_STAFF_SUCCEEDED = 'CREATE_SUITES_STAFF_SUCCEEDED'
export const CREATE_SUITES_STAFF_FAILED = 'CREATE_SUITES_STAFF_FAILED'

export const GET_SUITES_STAFF_REQUESTED = 'GET_SUITES_STAFF_REQUESTED'
export const GET_SUITES_STAFF_SUCCEEDED = 'GET_SUITES_STAFF_SUCCEEDED'
export const GET_SUITES_STAFF_FAILED = 'GET_SUITES_STAFF_FAILED'

export const UPDATE_TOGGLE = 'UPDATE_TOGGLE'

export const UPDATE_SUITES_STAFF_REQUESTED = 'UPDATE_SUITES_STAFF_REQUESTED'
export const UPDATE_SUITES_STAFF_SUCCEEDED = 'UPDATE_SUITES_STAFF_SUCCEEDED'
export const UPDATE_SUITES_STAFF_FAILED = 'UPDATE_SUITES_STAFF_FAILED'

export const REMOVE_SUITES_STAFF_REQUESTED = 'REMOVE_SUITES_STAFF_REQUESTED'
export const REMOVE_SUITES_STAFF_SUCCEEDED = 'REMOVE_SUITES_STAFF_SUCCEEDED'
export const REMOVE_SUITES_STAFF_FAILED = 'REMOVE_SUITES_STAFF_FAILED'

export const GET_EMPLOYEE_ROLES = 'GET_EMPLOYEE_ROLES'

export const SEARCH_SUITES_STAFF_SUCCEEDED = 'SEARCH_SUITES_STAFF_SUCCEEDED'

export const SET_ATTENDANT_STATUS_FILTER_VALUE = 'SET_ATTENDANT_STATUS_FILTER_VALUE'
